// @flow
import { FinectLogoPlus } from '@finect/tabular-components/FinectLogoPlus';
import { FinectLogo } from '@finect/tabular-components/FinectLogo';

export type OptionsType = 'basic' | 'free';

export const options = {
  free: {
    title: 'Navegar gratis con cookies',
    highlight: 'Disfruta al 100% de Finect',
    price: '0€',
    period: null,
    button: 'Aceptar cookies'
  },
  basic: {
    title: 'Navegar sin cookies',
    highlight: 'Sin publicidad',
    price: '1€',
    period: 'mes',
    button: 'Comprar'
  }
};

export const plusOptions = {
  free: {
    logo: FinectLogo,
    logoProps: { size: '150' },
    background: '#EFEFEF',
    color: '#000',
    color2: '#595959',
    title: 'Accede a Finect con restricciones:',
    bulletsSize: 1,
    bullets: [
      'Acceso a contenido básico',
      '5 comparaciones de productos de inversión al día',
      'Límite de 10 comparaciones guardadas',
      'Límite de 10 productos guardados',
      'Límite de 10 artículos guardados'
    ],
    price: 'Gratuito',
    button: 'Continuar',
    buttonColor: '#000',
    buttonBackgroundColor: '#D6D6D6'
  },
  basic: {
    background: 'linear-gradient(to right, #1f4891, #2ab6b9)',
    logo: FinectLogoPlus,
    color: '#fff',
    title: 'Accede a análisis y herramientas <b>sin límites</b>:',
    bulletsSize: 1.5,
    bullets: [
      'Crea y personaliza <b>Mi Cartera</b>',
      'Análisis exclusivos',
      'Comparaciones <b>ilimitadas</b>',
      'Guarda tus favoritos de forma <b>ilimitada</b>',
      'Herramientas financieras',
      '<b>Finect Trends</b>'
    ],
    priceFontSize: 5,
    period: 'mes*',
    priceYearlyPeriod: 'año*',
    button: 'Suscríbete a Finect Plus',
    buttonColor: '#fff',
    buttonBackgroundColor: '#1F4891',
    buttonBackgroundColor2: 'linear-gradient(to right, #2AB6B9, #26A7AE)'
  }
};
